import labels from "./labels";
import types from "./types";

const RouteLinks = [
	{ url: "/", title: labels.BreadCrumbLabels.lbl_home },
	{
		url: "/shopping/products",
		title: labels.BreadCrumbLabels.lbl_browse_products,
	},
	{
		url: "/shopping/product-compare",
		title: labels.BreadCrumbLabels.lbl_compare_products,
	},
	{
		url: "/shopping/product-details/[id]",
		title: labels.BreadCrumbLabels.lbl_product_details,
	},
	{
		url: "/shopping/cart",
		title: labels.BreadCrumbLabels.lbl_cart,
	},
	{
		url: types.DEAL_GRID_PAGE,
		title: labels.BreadCrumbLabels.lbl_browse_all_deals
	},
	{
		url: "/shopping/view-order-details",
		title: labels.BreadCrumbLabels.lbl_order_details
	},
	{
		url: "/shopping/view-order-history",
		title: labels.BreadCrumbLabels.lbl_order_history
	},
	{
		url: "/shopping/deal-details-page/[id]",
		title: labels.BreadCrumbLabels.lbl_deal_details
	},
	{
		url: "/shopping/deal-selection",
		title: labels.lbl_select_deal
	},
];

export default RouteLinks;
